export var dialog = {
  methods: {
    dialogType(custom) {
      let result = custom == 'confirm' ? 'warning' : custom;
      return result;
    },
    formattedNotification(data) {
      
      let notifications = [];
      const formatted = (notification) => {
        if (!notification.content || notification.content == '') {
          let formattedNotif = notification;
          switch (notification.custom) {
            case 'error': {
              formattedNotif.content = this.translatedText('errorText');
              break;
            }
            case 'success': {
              formattedNotif.content = this.translatedText('successText');
              break;
            }
          }
          return formattedNotif;
        } else {
          return notification;
        }
      }

      if (Array.isArray(data.content)) {
        if (data.content.length > 0) {
          data.content.forEach((notif) => {
            const fmt = formatted({
              custom: data.custom,
              content: notif,
            });
            notifications.push(fmt);
          });
        } else {
          const fmt = formatted({
            custom: data.custom,
            content: null,
          });
          notifications.push(fmt);
        }
      } else {
        notifications.push(formatted(data));
      }

      return notifications;
    }
  }
}